import { createAction } from "@ngrx/store";

export const entered = createAction("[Callback Page] Entered");
